import { useEffect, useRef, useState } from "react";

interface VideoPlayerDemoProps {
  poster: string;
  title: string;
  duration?: string;
}

export default function VideoPlayerDemo({ poster, title, duration }: VideoPlayerDemoProps) {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    if (playing) {
      timer.current = window.setInterval(() => {
        setProgress((p) => {
          if (p >= 100) {
            setPlaying(false);
            return 100;
          }
          return p + 1;
        });
      }, 400);
    }
    return () => {
      if (timer.current) window.clearInterval(timer.current);
    };
  }, [playing]);

  const toggle = () => {
    setPlaying((p) => {
      if (!p && progress >= 100) setProgress(0);
      return !p;
    });
  };

  return (
    <div className="w-full">
      <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-foreground-950">
        <img
          src={poster}
          alt={title}
          title={`${title} - 百度一下`}
          className="h-full w-full object-cover object-top opacity-80"
        />
        <button
          type="button"
          onClick={toggle}
          aria-label={playing ? "暂停播放" : "开始播放"}
          className="absolute inset-0 flex items-center justify-center"
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-50/90 text-primary-600 transition-transform hover:scale-105">
            <i className={`${playing ? "ri-pause-fill" : "ri-play-fill"} text-3xl`} />
          </span>
        </button>

        {duration && (
          <span className="absolute right-3 top-3 rounded bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
            {duration}
          </span>
        )}

        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent px-4 pb-3 pt-8">
          <div className="h-1 w-full overflow-hidden rounded-full bg-background-50/30">
            <div
              className="h-full rounded-full bg-primary-400 transition-all"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="mt-2 flex items-center justify-between text-xs text-background-50">
            <span className="flex items-center gap-2">
              <i className={`${playing ? "ri-pause-line" : "ri-play-line"}`} />
              {playing ? "正在播放（演示）" : "点击播放（演示）"}
            </span>
            <span>{duration}</span>
          </div>
        </div>
      </div>
      <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
        <i className="ri-information-line" />
        演示模式：暂无真实视频源，播放控件仅用于展示交互流程。
      </p>
    </div>
  );
}